/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconLayoutSidebarInactive = createReactComponent(
  "layout-sidebar-inactive",
  "IconLayoutSidebarInactive",
  [
    [
      "path",
      {
        d: "M4 6a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12z",
        key: "svg-0"
      }
    ],
    ["path", { d: "M9 4v1", key: "svg-1" }],
    ["path", { d: "M9 9v1", key: "svg-2" }],
    ["path", { d: "M9 14v1", key: "svg-3" }],
    ["path", { d: "M9 19v1", key: "svg-4" }]
  ]
);

export { IconLayoutSidebarInactive as default };
//# sourceMappingURL=IconLayoutSidebarInactive.js.map
